import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=4b67a22e&"
import script from "./Connections.vue?vue&type=script&lang=ts&"
export * from "./Connections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports